<template lang="pug">
.container.position-relative
  swiper.swiper-container.d-none.d-lg-block(
    :options="swiperOption",
    ref="mySwiper"
  )
    swiper-slide.swiper-slide(
      v-for="(claimInfo, index) in docDescriptions.ClaimInfo_area02_List",
      :key="index"
    )
      .doc_descriptions.d-flex.flex-column.align-items-center
        img(:src="claimInfo.ClaimInfo_area02_Image")
        h4 {{ claimInfo.ClaimInfo_area02_Title }}
        .doc_content
          .prepare(
            v-if="checkDocList(claimInfo.ClaimInfo_area02_DocContent01, 1)"
          )
            h5 保戶準備
              li(
                v-if="doc.area02_DocContent01_Type == 1",
                v-for="(doc, index) in claimInfo.ClaimInfo_area02_DocContent01",
                :key="index"
              )
                a(
                  v-if="doc.area02_DocContent01_FileURL",
                  :href="doc.area02_DocContent01_FileURL",
                  target="_blank"
                ) {{ doc.area02_DocContent01_Title }}
                  svg-icon(iconClass="ic_download", className="icon")
                span(v-else) {{ doc.area02_DocContent01_Title }}
          .provide(
            v-if="checkDocList(claimInfo.ClaimInfo_area02_DocContent01, 2)"
          )
            h5.i_mt_4 請對造協助提供
              li(
                v-if="doc.area02_DocContent01_Type == 2",
                v-for="(doc, index) in claimInfo.ClaimInfo_area02_DocContent01",
                :key="index"
              )
                a(
                  v-if="doc.area02_DocContent01_FileURL",
                  :href="doc.area02_DocContent01_FileURL",
                  target="_blank"
                ) {{ doc.area02_DocContent01_Title }}
                  svg-icon(iconClass="ic_download", className="icon")
                span(v-else) {{ doc.area02_DocContent01_Title }}
          .provide(
            v-if="checkDocList(claimInfo.ClaimInfo_area02_DocContent01, 3)"
          )
            h5.i_mt_4 不指定
              li(
                v-if="doc.area02_DocContent01_Type == 3",
                v-for="(doc, index) in claimInfo.ClaimInfo_area02_DocContent01",
                :key="index"
              )
                a(
                  v-if="doc.area02_DocContent01_FileURL",
                  :href="doc.area02_DocContent01_FileURL",
                  target="_blank"
                ) {{ doc.area02_DocContent01_Title }}
                  svg-icon(iconClass="ic_download", className="icon")
                span(v-else) {{ doc.area02_DocContent01_Title }}
  svg-icon.swiper-prev.d-none.d-lg-block(
    iconClass="arrow_left_large",
    className="icon",
    @click="prevClick"
  )

  svg-icon.swiper-next.d-none.d-lg-block(
    iconClass="arrow_right_large",
    className="icon",
    @click="nextClick"
  )
  .row.d-lg-none
    .col-12(
      v-for="(claimInfo, index) in docDescriptions.ClaimInfo_area02_List",
      :key="index"
    )
      doc-mobile(:claimInfo="claimInfo")
</template>

<script>
import DocMobile from "@/components/product/NormalCliamSettlementInfo/DocMobile";
export default {
  name: "DocDescriptions",
  props: {
    docDescriptions: Object,
  },
  components: {
    DocMobile,
  },
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        spaceBetween: 0,
        slidesPerView: 3,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
      },
    };
  },
  computed: {
    docDescriptionsSwiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    prevClick() {
      this.docDescriptionsSwiper.slidePrev();
    },
    nextClick() {
      this.docDescriptionsSwiper.slideNext();
    },
    checkDocList(docList, type) {
      for (let x in docList) {
        let doc = docList[x];
        if (type == doc.area02_DocContent01_Type) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/cliam_settlement_info/doc_descriptions";
</style>
